import React, { useState, useEffect } from 'react';

const Timer = () => {
  const calculateTimeLeft = () => {
    let year = new Date().getFullYear();
    const difference = +new Date(`${year}-05-8 16:00:00`) - +new Date();
    // const difference = +new Date(`${year}-05-8`) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach(interval => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span key={Math.random()}>
        {timeLeft[interval]} {interval}{' '}
      </span>
    );
  });
  return (
    <div style={{ fontSize: '2em', marginTop: '10px', textTransform: 'uppercase', textAlign: 'center', fontWeight: '900' }}>
      Time to Lines In:{' '}
      {timerComponents.length ? timerComponents : 'LINES IN!!'}
    </div>
  );
};

export default Timer;
